import React, { useMemo } from 'react';

import { withStyles, WithStyles } from '@material-ui/core';
import { get } from 'lodash';
import { getInitials, stringToColor } from 'ui-utils';
import { TUser } from 'ui-model';

import configService from '@lib/services/configService';
import storageService from '@lib/services/storageService';
import { Badge } from 'components/v2';
import Avatar, { AvatarProps } from 'components/v2/Avatar';

import styles from './MessageAvatar.styles';

export interface AvatarNodeProps extends WithStyles<typeof styles>, Omit<AvatarProps, 'classes'> {
  interlocutor: TUser;
}

const AvatarNode: React.FC<AvatarNodeProps> = ({ classes, interlocutor, size }) => {
  // @ts-ignore
  const { __t } = interlocutor;
  const variant = __t === 'Group' ? 'group' : 'default';

  const name: string =
    get(interlocutor, 'groupName') || get(interlocutor, 'name') || get(interlocutor, 'patient.name') || '';
  const avatar: string | null = get(interlocutor, 'avatar') || null;

  const initials = getInitials(name || '');
  const color = stringToColor(initials);

  const src = useMemo(() => {
    if (!avatar) {
      return;
    }
    const token = storageService.getToken();
    return `${configService.getApiBasePath()}/fileUploads/${avatar}/file?token=${token}`;
  }, [avatar]);

  return (
    <Badge classes={{ badge: classes.badge }} variant="dot" invisible>
      <Avatar variant={variant} color={color} src={src} size={size}>
        {src ? undefined : initials}
      </Avatar>
    </Badge>
  );
};

export default withStyles(styles)(AvatarNode);
